export default __webpack_public_path__ + "static/team-player-873dfedf599d30f95dcb63429bf8390c.png";